// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
	},
	selector: {
		products: '#product-loop'
	}
};

var bcSfFilterTemplate = {
	'saleLabelHtml': '<div class="sale-item icn">' + bcSfFilterConfig.label.sale + '</div>',
	'soldOutLabelHtml': '<div class="so icn">' + bcSfFilterConfig.label.sold_out + '</div>',
	'newLabelHtml': '<div class="new icn">' + bcSfFilterConfig.label.new + '</div>',
	'vendorHtml': '<h4>{{itemVendorLabel}}<h4>',
	'quickViewHtml': '<a class="fancybox.ajax product-modal" href="{{itemUrl}}?view=quick">' + bcSfFilterConfig.label.quick_view + '</a>',

	'productGridItemHtml':  '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}} tablet-half mobile-half" data-alpha="{{itemTitle}}" data-price="{{itemPriceNumber}}">' +
								'<div class="product-index-inner">' +
									'{{itemNewLabel}}' +
									'{{itemSaleLabel}}' +
									'{{itemSoldoutLabel}}' +
								'</div>' +
								'<div class="prod-image">' +
									'<a href="{{itemUrl}}" title="{{itemTitle}}">' +
										'<div class="reveal">' +
											'{{itemImages}}' +
										'</div>' +
									'</a>' +
									'{{itemQuickView}}' +
								'</div>' +
								'<div class="product-info">' +
									'<div class="product-info-inner">' +
										'<a href="{{itemUrl}}">' +
											'{{itemVendor}}' +
											'<span class="prod-title">{{itemTitle}}</span>' +
										'</a>' +
										'<div class="price">{{itemPrice}}</div>' +
										'{{itemSwatch}}' +
									'</div>' +
								'</div>' +
							'</div>',

	// Pagination Template
	'previousHtml': '<div class="pagiprev"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-left"></i></a></div>',
	'nextHtml': '<div class="paginext"><a href="{{itemUrl}}" title=""><i class="fa fa-caret-right"></i></a></div>',
	'pageItemHtml': '<a href="{{itemUrl}}" title="">{{itemTitle}}</a>',
	'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '{{itemTitle}}',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
	'paginateTopHtml': '{{previous}} <span class="pagination-count"></span> {{next}}',
  
	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by" class="styled-select">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function (data, index, totalProduct) {
	/*** Prepare data ***/
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	// Add itemGridWidthClass
	var itemGridWidthClass = '';
	var productsPerRow = bcSfFilterConfig.custom.products_per_row;
	switch (productsPerRow) {
		case 6:
			itemGridWidthClass = buildItemGridClass('desktop-2', index, productsPerRow);
			break;
		case 4:
			itemGridWidthClass = buildItemGridClass('desktop-3', index, productsPerRow);
			break;
		case 3:
			itemGridWidthClass = buildItemGridClass('desktop-4', index, productsPerRow);
			break;
		case 5:
			itemGridWidthClass = buildItemGridClass('desktop-fifth', index, productsPerRow);
			break;
		case 2:
			itemGridWidthClass = buildItemGridClass('desktop-6', index, productsPerRow);
			break;
		default:
			break;
	}
	itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

	// Add Label
	var itemNewLabelHtml = '';
	var itemSaleLabelHtml = '';
	var itemSoldoutLabelHtml = '';
	if (!soldOut) {
		for (var k in data.collections) {
			if (data['collections'][k]['handle'] == 'new') {
				itemNewLabelHtml = bcSfFilterTemplate.newLabelHtml;
				break;
			}
		}
		if (onSale) {
			itemSaleLabelHtml = bcSfFilterTemplate.saleLabelHtml.replace(/{{itemOldPrice}}/g, this.formatMoney(data.price_min, this.moneyFormat));
		}
	} else {
		itemSoldoutLabelHtml = bcSfFilterTemplate.soldOutLabelHtml;
	}
	itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
	itemHtml = itemHtml.replace(/{{itemSoldoutLabel}}/g, itemSoldoutLabelHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add price
	var itemPriceHtml = '';
	if (onSale) {
		itemPriceHtml += '<div class="onsale">' + this.formatMoney(data.price_min, this.moneyFormat) + '</div>';
		itemPriceHtml += '<div class="was">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</div>';
	} else {
		itemPriceHtml += '<div class="prod-price">';
		if (priceVaries) {
			itemPriceHtml += bcSfFilterConfig.label.from_price + ' ' + this.formatMoney(data.price_min, this.moneyFormat) + ' - ' + this.formatMoney(data.price_max, this.moneyFormat);
		} else {
			itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
		}
		itemPriceHtml += '</div>';
	}
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add itemImages
	var itemImagesHtml = '';
	var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;
	if (images.length > 0) {
		var aspect_ratio = images[0]['height'] / images[0]['width'] * 100;
		var firstImageCLass = (images.length > 0 && bcSfFilterConfig.custom.secondary_images_hover == 'image-flip') ? 'first-image' : '';
		itemImagesHtml += '<div class="box-ratio" style="padding-bottom: ' + aspect_ratio + '%;">' +
			'<img class="lazyload lazyload-fade ' + firstImageCLass + '"' +
			'data-src="' + this.optimizeImage(images[0]['src'], '{width}x') + '"' +
			'data-sizes="auto"' +
			'data-original="' + itemThumbUrl + '"' +
			'alt="{{itemTitle}}">' +
			'</div>' +
			'<noscript>' +
			'<img src="' + this.optimizeImage(images[0]['src'], '1024x') + '" alt="{{itemTitle}}">' +
			'</noscript>';
		if (bcSfFilterConfig.custom.secondary_images_hover == 'image_flip' && images.length > 1) {
			var aspect_ratio1 = images[1]['height'] / images[1]['width'] * 100;
			itemImagesHtml += '<div class="hidden">'+
				'<div class="box-ratio" style="padding-bottom: ' + aspect_ratio1 + '%;">' +
				'<img class="lazyload lazyload-fade"' +
				'data-src="' + this.optimizeImage(images[1]['src'], '{width}x') + '"' +
				'data-sizes="auto"' +
				'data-original="' + itemThumbUrl + '"' +
				'alt="{{itemTitle}}">' +
				'</div>' +
				'<noscript>' +
				'<img src="' + this.optimizeImage(images[1]['src'], '1024x') + '" alt="{{itemTitle}}">' +
				'</noscript>' +
				'</div>';
		}
	} else {
		itemImagesHtml += '<img src="' + itemThumbUrl + '">';
	}

	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Quick view
	var itemQuickViewHtml = bcSfFilterConfig.custom.quick_view_enable ? bcSfFilterTemplate.quickViewHtml : '';
	itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

	// Add Swatches
	var itemSwatchHtml = '';
	if (bcSfFilterConfig.custom.secondary_images_hover == 'alternate_colors' && images.length > 1) {
		for (var k = 0; k < data.options_with_values.length; k++) {
			var option = data['options_with_values'][k]['name'];
			var option_handle = this.slugify(option);
			var option_index = k;

			var is_color = false;
			var downcased_option = option.toLowerCase();
			if (downcased_option.indexOf('color') > -1 || downcased_option.indexOf('colour') > -1) {
				itemSwatchHtml += '<div class="col-swatch">'
				itemSwatchHtml += '<ul data-option-index="' + option_index + '" class="' + option_handle + ' options">';
				var values = '';
				var optionValues = data['options_with_values'][k]['values'];
				for (var i = 0; i < optionValues.length; i++) {
					var value = optionValues[i]['title'];
					var wrapped_value = ',' + value + ',';
					if (values.indexOf(wrapped_value) == -1) {
						var variantImage = "";
						if (optionValues[i]['image'] != null) {
							var imageIndex = optionValues[i]['image'];
							if (typeof (images[imageIndex - 1]) !== 'undefined') {
								variantImage = this.optimizeImage(images[imageIndex - 1]['src']);
							}
						}
						var fileColorUrl = bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', this.slugify(value) + '.png');
						itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + variantImage + '" class="color ' + this.slugify(value) + '">';
						itemSwatchHtml += '<span style="background-color: ' + this.slugify(value.split(' ').pop()) + '; background-image: url(' + fileColorUrl + ')"></span>';
						itemSwatchHtml == '</li>';
						values += values + wrapped_value;
					}
				}
				itemSwatchHtml += '</ul>';
				itemSwatchHtml += '</div>';
			}
		}

		itemSwatchHtml += '<script>' +
			"$('#product-listing-{{itemId}} .col-swatch li').each(function(){" +
				"var Original = $('#product-listing-{{itemId}} .prod-image img').attr('data-original'); " +
				"$(this).hover(function() {" +
					"var newImage = $(this).attr('data-href');" +
					"if (newImage){"+
						"$( '#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: newImage }); " +
					"}" +
					"return false;" +
				"}, function(){" +
					"$('#product-listing-{{itemId}} .prod-image img' ).attr({ srcset: Original }); " +
				"});" +
			"});" +
		'</script>';
	}
	itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemPriceNumber}}/g, this.formatMoney(data.price_min, this.moneyFormat));
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariant.id);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
}

function buildItemGridClass(itemClass, index, productsPerRow) {
	var temp = index < productsPerRow ? index : index % productsPerRow;
	if (temp == 1) { itemClass += ' first'; } else if (temp == 0) { itemClass += ' last'; };
	return itemClass;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		var paginationTopHtml = bcSfFilterTemplate.paginateTopHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		paginationTopHtml = paginationTopHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		paginationTopHtml = paginationTopHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage in pageArr) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content 
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data) {
	// Build Total Products
	if (this.getSettingValue('general.paginationType') == 'default') {
		var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
		var to = from + data.products.length - 1;
		jQ('#pagination').find('.count').html(bcSfFilterConfig.label.showing_items + ' ' + from + '-' + to + ' ' + bcSfFilterConfig.label.pagination_of + ' ' + data.total_product);

		// Build Top Pagination info
		var currentPage = parseInt(this.queryParams.page);
		var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
		jQ('#bc-sf-filter-top-pagination').find('.pagination-count').html(currentPage + ' ' + bcSfFilterConfig.label.pagination_of + ' ' + totalPage + ' ');
	} else {
		jQ('#pagination').hide();
		jQ('#bc-sf-filter-top-pagination').hide();
	}
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
